import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import ButtonIconV2 from '../common/ButtonIconV2';

import IconCheckout from './svg/IconCheckout';

function ButtonCheckout({ id }) {
  const onClick = () => {
    window.open(`https://www.${Config.API_NAME}.com/cart/cart/${id}`, `_blank`);
  }
  return <ButtonIconV2
    icon={<IconCheckout />}
    label={`Checkout`}
    onClick={onClick}
  />
}

ButtonCheckout.propTypes = {
  id: PropTypes.number.isRequired
}

export default ButtonCheckout;
